"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupShowAll = void 0;
var Utilities_1 = require("../../Utilities");
var GroupShowAll_styles_1 = require("./GroupShowAll.styles");
var GroupShowAll_base_1 = require("./GroupShowAll.base");
exports.GroupShowAll = Utilities_1.styled(GroupShowAll_base_1.GroupShowAllBase, GroupShowAll_styles_1.getStyles, undefined, { scope: 'GroupShowAll' });
//# sourceMappingURL=GroupShowAll.js.map